import { memo, FC, useState, useEffect } from 'react'

import { format } from 'date-fns'

import { TimeContainer } from '@/components/MainSidebar/styles'
import i18n from '@/i18n'

const getTime = () => {
  const isUSLocale = i18n.language.includes('US')
  return format(new Date(), isUSLocale ? 'h:mma' : 'HH:mm')
}

type Props = { isCentered: boolean }

const TimeRaw: FC<Props> = ({ isCentered }) => {
  const [time, setTime] = useState(getTime)

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTime(getTime())
    }, 20_000)

    return () => {
      clearInterval(intervalId)
    }
  }, [])

  return <TimeContainer $isCentered={isCentered}>{time}</TimeContainer>
}

export const Time = memo(TimeRaw)
